import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';

const siteUrl = 'https://niuniu.tv';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '牛牛影视',
  url: siteUrl,
  description: '牛牛影视全站免费，覆盖电影大全、电视剧全集、热门综艺与精品动漫，高清流畅不缓冲，打造免费影视聚合入口。',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '牛牛影视',
  url: siteUrl,
  description: '免费高清影视聚合平台',
  sameAs: [],
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="牛牛影视 - 牛牛免费看高清电影大全 | 免费追剧在线观看与免费影视电视剧全集"
        description="牛牛影视全站免费，牛牛免费看覆盖电影大全、电视剧全集与综艺，免费追剧在线观看无需付费，高清流畅不缓冲，打造免费影视聚合入口。"
        keywords="牛牛影视,牛牛免费,免费追剧,免费影视,牛牛免费看,高清在线观看,电影大全,电视剧全集,不缓冲,免费观看"
        canonicalUrl={siteUrl}
        schemaData={{ ...homeSchema, ...orgSchema }}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedSection />
          <TrendingSection />
          <LatestSection />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
                为什么选择牛牛影视？
              </h2>
              <p className="text-sm text-foreground-500 mb-8 max-w-2xl mx-auto">
                我们用实际行动，让每一位用户都能享受高品质的免费观影体验
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '全站免费',
                    desc: '所有影视内容完全免费，无需会员、无需付费，真正实现看片自由',
                  },
                  {
                    icon: 'ri-4k-line',
                    title: '高清画质',
                    desc: '支持1080P超清画质，画面细腻流畅，带来影院级的观影感受',
                  },
                  {
                    icon: 'ri-speed-up-line',
                    title: '极速加载',
                    desc: '全球CDN加速节点，视频秒开不缓冲，告别漫长等待',
                  },
                  {
                    icon: 'ri-smartphone-line',
                    title: '多端同步',
                    desc: '电脑、平板、手机随心切换，观影记录云端同步，随时随地继续追',
                  },
                ].map((item) => (
                  <div key={item.title} className="flex flex-col items-center gap-3 p-6 bg-background-50 rounded-xl border border-background-200/70">
                    <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                      <i className={`${item.icon} text-xl`}></i>
                    </span>
                    <h3 className="text-base font-semibold text-foreground-950 font-heading">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-primary-500">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
                开启你的免费追剧之旅
              </h2>
              <p className="text-sm text-background-50/80 mb-8 max-w-xl mx-auto">
                海量影视资源，每日更新不停歇。现在就加入牛牛影视，享受纯粹的高清观影体验。
              </p>
              <a
                href="/category/movie"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-2-line text-lg"></i>
                开始观影
              </a>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}